module.exports = "/assets/262b9d4b5d8a52aad9acab3512a0cb83.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/BI.png
// module id = 1231
// module chunks = 0